// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__1WP5m","list":"styles_list__HyfwY","item":"styles_item__1fkBX"};